<template>
    <h1 class="page-title" @click="handleTitleClick"><slot></slot></h1>

</template>

<script>
    export default {
        methods: {
          handleTitleClick() {
            this.$emit('click');
          }
        },
    }
</script>

<style scoped lang="scss">

    @import './variables';

    .page-title {
        color: $primary-blue;
        font-family: $title-font;
        font-size: 2.2rem;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        margin-top: 0;
        margin-bottom: 1.2rem;
    }

</style>
